import NotificationList from 'modules/notification/components/NotificationList/NotificationList';

const NotificationListPage = () => {
    return <NotificationList />;
};

export default NotificationListPage;
